export default __webpack_public_path__ + "static/media/fruicrose.2c0b7e7e.png";